import React from 'react';
import { useSelector } from 'react-redux';
import { ProgressiveLoadOverlay } from '../components/progressive-load-overlay';
import { rateQuoteStatusLoading } from '../selectors/rate-quote/progressive-loading';

export const ProgressiveLoading = () => {
  const loading = useSelector(rateQuoteStatusLoading);
  return <ProgressiveLoadOverlay loading={loading} />;
};
